import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from './store/store';

const ProtectedRoute: React.FC = () => {
  const { access } = useSelector((state: RootState) => state.user);

  return access ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
